import { AuthenticationCreateAccount } from "@/Shared/Authentication/CustomComponents/AuthenticationCreateAccount";
import { BookShipmentAuthenticationPane } from "../../CustomComponents/Internal/bookShipmentAuthenticationPane";
import type { CreateAccountPaneProps } from "./AuthenticateForQuotesDialogBody";

export function CreateAccountPane(props: CreateAccountPaneProps) {
  const { onSignInInstead } = props;

  return (
    <BookShipmentAuthenticationPane>
      <AuthenticationCreateAccount
        onSignInInstead={onSignInInstead}
        onSuccess={props.onDone}
      />
    </BookShipmentAuthenticationPane>
  );
}
